export default __webpack_public_path__ + "static/media/649.3697c70e.png";